module.exports = "<div class=\"ctx-percentage-bar-content\">\n    <div class=\"left-labels grid-labels\"\n         style=\"width: 20%;\"></div>\n    <div class=\"svg-graph\"\n         style=\"width: 60%\"></div>\n    <div class=\"right-labels grid-labels\"\n         style=\"width: 20%;\"></div>\n    <div class=\"grid-container\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxPercentageBar/ctxPercentageBar.template.html
// module id = 283
// module chunks = 0 1